import React, { useEffect } from "react";
import { Router } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { ToastContainer, toast } from "react-toastify";
import Routes from "./routes";
import GlobalStyle from "./styles/global";
import CookiesAndTerms from "./pages/CookiesAndTerms";
import AdBlockAlert from "./pages/AdBlockAlert";
import history from "./services/history";
import { store, persistor } from "./store";

import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";
import { LightTheme, BaseProvider } from "baseui";
import { setSessionStorageKey } from "./utils";

import "./config/ConfigApplication";

import { ThemeProvider } from "styled-components";
import dark from "./styles/theme/dark";
import Adjust from "@adjustcom/adjust-web-sdk";

const engine = new Styletron();

function App() {
	useEffect(() => {
		const host = window.location.host;
		const envAdjust =
			host === "localhost" || host.includes("alpha") || host.includes("stage")
				? "sandbox"
				: "production";
		const logLevel = envAdjust === "sandbox" ? "verbose" : "none";

		Adjust.initSdk({
			appToken: "2178x3yqbolc",
			environment: envAdjust,
			logLevel,
		});
	}, []);

	useEffect(() => {
		setSessionStorageKey("utm_source", new URLSearchParams(window.location.search).get("utm_source"));
		setSessionStorageKey("utm_medium", new URLSearchParams(window.location.search).get("utm_medium"));
		setSessionStorageKey(
			"utm_campaign",
			new URLSearchParams(window.location.search).get("utm_campaign")
		);
	});

	return (
		<StyletronProvider value={engine}>
			<BaseProvider theme={LightTheme}>
				<ThemeProvider theme={dark}>
					<Provider store={store}>
						<PersistGate persistor={persistor}>
							<Router history={history}>
								<Routes />
								<GlobalStyle />
								<CssBaseline />
								<ToastContainer
									position={
										toast.POSITION
											.BOTTOM_RIGHT
									}
									autoClose={3000}
								/>
								<CookiesAndTerms />
								<AdBlockAlert />
							</Router>
						</PersistGate>
					</Provider>
				</ThemeProvider>
			</BaseProvider>
		</StyletronProvider>
	);
}

export default App;
